"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToastProvider = exports.ToastContext = void 0;
var _react = _interopRequireWildcard(require("react"));
var _useToastQueue2 = require("./useToastQueue");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const ToastContext = /*#__PURE__*/(0, _react.createContext)({
  activeToast: undefined,
  addToast: () => {},
  removeToast: () => {},
  hideToast: () => {},
  clearToastQueue: () => {},
  pauseTimer: () => {},
  resumeTimer: () => {}
});
exports.ToastContext = ToastContext;
const ToastProvider = ({
  children,
  toastBottomOffset
}) => {
  var _element$props$bottom;
  const _useToastQueue = (0, _useToastQueue2.useToastQueue)(),
    activeToast = _useToastQueue.activeToast,
    addToast = _useToastQueue.addToast,
    removeToast = _useToastQueue.removeToast,
    hideToast = _useToastQueue.hideToast,
    clearToastQueue = _useToastQueue.clearToastQueue,
    pauseTimer = _useToastQueue.pauseTimer,
    resumeTimer = _useToastQueue.resumeTimer;
  const element = activeToast === null || activeToast === void 0 ? void 0 : activeToast.element;
  const memoizedContextValue = (0, _react.useMemo)(() => ({
    addToast,
    removeToast,
    hideToast,
    clearToastQueue,
    pauseTimer,
    resumeTimer
  }), [addToast, removeToast, hideToast, clearToastQueue, pauseTimer, resumeTimer]);
  return /*#__PURE__*/_react.default.createElement(ToastContext.Provider, {
    value: memoizedContextValue
  }, children, /*#__PURE__*/(0, _react.isValidElement)(element) && toastBottomOffset ?
  /*#__PURE__*/
  // props level offset should have higher specificity
  (0, _react.cloneElement)(element, {
    bottomOffset: (_element$props$bottom = element.props.bottomOffset) !== null && _element$props$bottom !== void 0 ? _element$props$bottom : toastBottomOffset
  }) : element);
};
exports.ToastProvider = ToastProvider;